import { flattenPalette } from './utils';
export var palette = {
  primary: {
    lightest: 'hsl(21, 81%, 92%)',
    lighter: 'hsl(22, 85%, 86%)',
    light: 'hsl(23, 90%, 54%)',
    base: 'hsl(19, 100%, 42%)',
    dark: 'hsl(18, 90%, 36%)',
    darker: 'hsl(17, 85%, 32%)',
    darkest: 'hsl(16, 81%, 20%)'
  },
  warning: {
    lighter: 'hsl(60, 99%, 90%)',
    light: 'hsl(56, 97%, 74%)',
    base: 'hsl(50, 94%, 56%)',
    dark: 'hsl(48, 93%, 48%)',
    darker: 'hsl(42, 90%, 30%)'
  },
  error: {
    lighter: 'hsl(7, 60%, 90%)',
    light: 'hsl(7, 72%, 76%)',
    base: 'hsl(7, 78%, 64%)',
    dark: 'hsl(7, 80%, 52%)',
    darker: 'hsl(7, 86%, 30%)'
  },
  success: {
    lighter: 'hsl(96, 24%, 92%)',
    light: 'hsl(96, 32%, 76%)',
    base: 'hsl(96, 40%, 58%)',
    dark: 'hsl(96, 44%, 50%)',
    darker: 'hsl(96, 60%, 20%)'
  },
  red: ['hsl(8, 73%, 96%)', 'hsl(8, 74%, 92%)', 'hsl(8, 75%, 88%)', 'hsl(8, 76%, 68%)', 'hsl(8, 77%, 60%)', 'hsl(8, 78%, 56%)', 'hsl(8, 79%, 52%)', 'hsl(8, 80%, 48%)', 'hsl(8, 81%, 40%)', 'hsl(8, 82%, 30%)'],
  blue: ['hsl(197, 56%, 92%)', 'hsl(197, 56%, 88%)', 'hsl(197, 56%, 72%)', 'hsl(197, 56%, 64%)', 'hsl(197, 56%, 52%)', 'hsl(197, 56%, 44%)', 'hsl(197, 56%, 40%)', 'hsl(197, 56%, 32%)', 'hsl(197, 56%, 24%)', 'hsl(197, 56%, 20%)'],
  green: ['hsl(96, 24%, 92%)', 'hsl(96, 30%, 84%)', 'hsl(96, 32%, 76%)', 'hsl(96, 34%, 72%)', 'hsl(96, 36%, 64%)', 'hsl(96, 40%, 58%)', 'hsl(96, 44%, 50%)', 'hsl(96, 48%, 40%)', 'hsl(96, 52%, 30%)', 'hsl(96, 60%, 20%)'],
  yellow: ['hsl(50, 89%, 90%)', 'hsl(50, 90%, 86%)', 'hsl(50, 91%, 74%)', 'hsl(50, 92%, 68%)', 'hsl(50, 93%, 62%)', 'hsl(50, 94%, 56%)', 'hsl(50, 95%, 48%)', 'hsl(50, 96%, 40%)', 'hsl(50, 97%, 32%)', 'hsl(50, 98%, 26%)'],
  light: ['hsla(0,0%,100%,0.16)', 'hsla(0,0%,100%,0.24)', 'hsla(0,0%,100%,0.32)', 'hsla(0,0%,100%,0.44)', 'hsla(0,0%,100%,0.50)', 'hsla(0,0%,100%,0.60)', 'hsla(0,0%,100%,0.68)', 'hsla(0,0%,100%,0.76)', 'hsla(0,0%,100%,0.88)', 'hsla(0,0%,100%,0.96)'],
  dark: ['hsla(0,0%,0%,0.04)', 'hsla(0,0%,0%,0.08)', 'hsla(0,0%,0%,0.12)', 'hsla(0,0%,0%,0.16)', 'hsla(0,0%,0%,0.24)', 'hsla(0,0%,0%,0.32)', 'hsla(0,0%,0%,0.40)', 'hsla(0,0%,0%,0.46)', 'hsla(0,0%,0%,0.54)', 'hsla(0,0%,0%,0.68)'],
  grey: ['hsl(200,1%,98%)', 'hsl(200,1%,96%)', 'hsl(200,1%,94%)', 'hsl(200,1%,92%)', 'hsl(200,1%,90%)', 'hsl(200,1%,86%)', 'hsl(200,1%,74%)', 'hsl(200,1%,58%)', 'hsl(200,1%,46%)', 'hsl(200,1%,28%)'],
  foreground: {
    foreground: 'grey-9',
    foregroundSecondary: 'grey-8',
    foregroundTertiary: 'grey-7'
  },
  background: {
    background: 'hsl(30, 9%, 99%)',
    backgroundSecondary: 'hsl(30, 9%, 97%)',
    backgroundTertiary: 'hsl(30, 9%, 95%)'
  },
  surface: {
    surface: 'white',
    surfaceSecondary: 'grey-0',
    surfaceTertiary: 'grey-1'
  },
  separator: {
    separator: 'grey-6',
    separatorSecondary: 'grey-5',
    separatorTertiary: 'grey-4',
    separatorHover: 'separator',
    separatorFocus: 'primary',
    separatorFocusSecondary: 'primary-lighter'
  },
  highlight: {
    highlight: 'grey-2',
    highlightSecondary: 'grey-3'
  },
  link: {
    linkForeground: 'blue-5',
    linkBackground: 'hsl(200,100%,98%)'
  },
  days: {
    sunday: '#7DC156',
    monday: '#789FF8',
    tuesday: '#A193FD',
    wednesday: '#D18CF6',
    thursday: '#FA7EA4',
    friday: '#F69688',
    saturday: '#66BEEB'
  },
  apps: {
    'check-ins': '#8c6999',
    giving: '#f4c551',
    groups: '#f58a4f',
    'music-stand': '#4984c4',
    pco: '#3565cf',
    people: '#5781cf',
    'planning-center': '#2266f7',
    projector: '#f19900',
    registrations: '#569690',
    calendar: '#cc4832',
    services: '#6a9639'
  }
};
export var colors = flattenPalette(palette);
export function getColor(key) {
  return key ? colors[key] : colors;
}